export default "__VITE_ASSET__DGu2kCuc__"